import { Component, inject, input } from '@angular/core';

import { BaseComponent, BaseEditFormModalComponent, ModalService } from 'tms-lib';
import { AddressDetails, AddressService, SupplierAddressEdit, SupplierAddressService } from 'tms-web-shared';
import { AddressDetailsComponent } from '../address-details/address-details.component';

@Component({
  selector: 'app-supplier-address-create-modal',
  templateUrl: './supplier-address-create-modal.component.html',
  styleUrl: './supplier-address-create-modal.component.scss',
  imports: [BaseEditFormModalComponent, AddressDetailsComponent],
})
export class SupplierAddressCreateModalComponent extends BaseComponent {
  protected readonly addressService = inject(AddressService);
  private readonly supplierAddressService = inject(SupplierAddressService);
  private readonly modalService = inject(ModalService);

  public readonly id = input<string>();

  saved(model: AddressDetails) {
    const supplierAddress = { addressId: model.id, supplierId: this.id() } as SupplierAddressEdit;
    this.supplierAddressService
      .save(supplierAddress)
      .pipe(this.untilDestroyed())
      .subscribe(() => this.modalService.close(supplierAddress));
  }
}
